var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m12.981 1.926 2.335 7.568h7.612c.486 0 .705.663.292.969l-6.153 4.689 2.359 7.568c.146.484-.39.892-.778.586l-6.153-4.663-6.153 4.689c-.39.306-.949-.102-.779-.586l2.36-7.569-6.154-4.689c-.389-.306-.194-.968.292-.968h7.612l2.335-7.594a.507.507 0 0 1 .973 0Z",
  fill: "currentColor"
})));
export default SvgStar;